import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoMedical from "../../assets/logo-medical.png";
import NextButton from "../../components/NextButton";
import { useGameTexts } from "../../hooks/useGameTexts";
import { SERVER_URL } from "../../api";
import { ROUTES } from "../../utils/constants";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

const DEFAULT_TITLE = "Actitud terapéutica";
const DEFAULT_CONTENT = "<p><strong>Tres meses más tarde,&nbsp;</strong><br><strong>Martina acude a tu consulta.</strong></p><p>Antes de que entre, revisas los resultados de sus analíticas. Obsérvalos con atención.</p><p>Consumo C3 (mes 1 – mes 3): 12 mg/dl&nbsp;<br>Consumo C4 (mes 1 – mes 3): 2 mg/dl&nbsp;</p>";

function Scenario5Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state?.group);
	const { texts, ready } = useGameTexts(group?.game);
	const [imageLoaded, setImageLoaded] = useState(false);

	const title = texts["scenario5.intro.title"] ?? DEFAULT_TITLE;
	const content = texts["scenario5.intro.content"] ?? DEFAULT_CONTENT;
	const imageUrl = texts["scenario5.intro.image"] ? buildImageUrl(texts["scenario5.intro.image"]) : null;

	// Precargar imagen en segundo plano; solo mostrar cuando esté cargada para evitar parpadeo
	useEffect(() => {
		if (!imageUrl) {
			setImageLoaded(false);
			return;
		}
		setImageLoaded(false);
		const img = new Image();
		let cancelled = false;
		img.onload = () => { if (!cancelled) setImageLoaded(true); };
		img.onerror = () => { if (!cancelled) setImageLoaded(false); };
		img.src = imageUrl;
		return () => { cancelled = true; img.src = ""; };
	}, [imageUrl]);

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} alt="" />
				</div>
				<div
					style={{ paddingLeft: "6vh" }}
					className="row d-flex justify-content-start align-items-start mt-5 pt-5"
				>
					{!ready ? (
						<>
							<div className="col-4 txtWhite">
								<div className="txtWhite txt20" style={{ letterSpacing: 3 }}>ESCENARIO 5</div>
								<div style={{ height: 28, width: "80%", background: "rgba(255,255,255,0.2)", borderRadius: 4, marginTop: 16 }} aria-hidden />
								<div style={{ height: 80, width: "100%", background: "rgba(255,255,255,0.15)", borderRadius: 4, marginTop: 12 }} aria-hidden />
							</div>
							<div className="col-8" style={{ marginTop: "-10vh" }}>
								<div style={{ width: 600, height: 400, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
							</div>
						</>
					) : (
						<>
					<div className="col-4 txtWhite">
						<div
							className="txtWhite txt20"
							style={{ letterSpacing: 3 }}
						>
							ESCENARIO 5
						</div>
						<div
							className="txtWhite txt30 bold mt-3"
							style={{ letterSpacing: 3, lineHeight: "35px" }}
							dangerouslySetInnerHTML={{ __html: title }}
						/>
						<div style={{ lineHeight: "20px" }} dangerouslySetInnerHTML={{ __html: content }} />
					</div>
					<div className="col-8" style={{ marginTop: "-10vh" }}>
						{imageUrl && imageLoaded ? (
							<img src={imageUrl} width={600} alt="" style={{ display: "block" }} />
						) : (
							<div style={{ width: 600, height: 400, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
						)}
					</div>
						</>
					)}
					<div
						className="container"
						style={{
							position: "absolute",
							right: "7vh",
							bottom: "7vh",
						}}
					>
						<div className="d-flex justify-content-end">
							<NextButton
								navigateTo={ROUTES.SCENARIO5_CONVERSATION}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario5Intro);
